import { ExpirationOptions, type ExpirationType } from "@repo/api/src/schemas/order.schema";
import { type Locale, localeDateLocale } from "../i18n/locales";

type ExpirationMessageKey =
	| "uploadModal.expiration.hour"
	| "uploadModal.expiration.day"
	| "uploadModal.expiration.week"
	| "uploadModal.expiration.unlimited";

type ExpirationTranslator = (key: ExpirationMessageKey, params?: Record<string, string | number>) => string;

export function getExpirationDateTime(type: ExpirationType, locale: Locale, t: ExpirationTranslator): string {
	const now = new Date();
	const dateLocale = localeDateLocale(locale);

	switch (type) {
		case ExpirationOptions.HOUR: {
			const targetDate = new Date(now.getTime() + 60 * 60 * 1000);
			return t("uploadModal.expiration.hour", { time: targetDate.toLocaleTimeString(dateLocale) });
		}
		case ExpirationOptions.DAY: {
			const targetDate = new Date(now.getTime() + 24 * 60 * 60 * 1000);
			return t("uploadModal.expiration.day", { date: targetDate.toLocaleDateString(dateLocale) });
		}
		case ExpirationOptions.WEEK: {
			const targetDate = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
			return t("uploadModal.expiration.week", { date: targetDate.toLocaleDateString(dateLocale) });
		}
		case ExpirationOptions.UNLIMITED:
			return t("uploadModal.expiration.unlimited");
	}
}
